import { ModelBase } from 'store/model-base';

export class CmsLineTransfer extends ModelBase {
    public static storeName: string = 'cmsLineTransfer';

    public pageTitle: string;
    public sourceAccount: CmsLineTransferAccount;
    public targetAccount: CmsLineTransferAccount;
    public cancelLineTransfer: LineTransferCancelRequestModalContent;
    public requestNewPin: LineTransferCancelRequestModalContent;
}
